import {Observable} from 'rxjs';
import {change} from 'redux-form';

import {combineEpics} from 'web-app/util/redux-observable';
import InboxApi from 'web-app/api/inbox-api';
import * as FileActions from 'web-app/react/components/file-upload/actions';
import {archiveConversation} from 'web-app/react/inbox/conversation/actions';
import {hasValue} from 'web-app/util/typescript';

import * as Actions from './actions';
import * as Constants from './constants';

const sendNewMessage = action$ =>
    action$.ofType(Actions.sendNew.type).mergeMap(({payload}) => {
        const {participants, body, imageIds, fileIds, shouldArchive, sendAsSms} = payload;

        return InboxApi.sendNewMessageObservable(body, participants, imageIds, fileIds, sendAsSms)
            .flatMap(response =>
                [
                    Actions.sendNewSuccess.action({newMessage: response}),
                    FileActions.clearFiles(Constants.FORM),
                    change(Constants.FORM, 'body', ''),
                    shouldArchive ? archiveConversation.action(response.conversationId) : null,
                ].filter(hasValue),
            )
            .catch(e => Observable.of(Actions.sendNewFailed.action(e)));
    });

const reply = action$ =>
    action$.ofType(Actions.reply.type).mergeMap(({payload}) => {
        const {conversationId, body, imageIds, fileIds, shouldArchive, sendAsSms} = payload;

        return InboxApi.replyMessageObservable(body, conversationId, imageIds, fileIds, sendAsSms)
            .flatMap(response =>
                [
                    Actions.replySuccess.action(response, conversationId),
                    shouldArchive ? archiveConversation.action(response.conversationId) : null,
                    FileActions.clearFiles(Constants.FORM),
                    change(Constants.FORM, 'body', ''),
                ].filter(hasValue),
            )
            .catch(e => Observable.of(Actions.replyFailed.action(e)));
    });

export default combineEpics(sendNewMessage, reply);
